export const DIALOG_TITLE_LABEL = 'Import Events'

export const IMPORT_EVENTS_AUTOCOMPLETE_TEST_ID = 'import-event-autocomplete'
